import {createContext} from 'react'
import {useContext} from 'react'

const AppContext = createContext({

})
 
export const useAppContext = () => useContext(AppContext)

export default AppContext